import React from "react";
import { useEffect } from "react";
import Footer from "./Footer";
import HeaderInner from "./HeaderInner";
import { useDispatch, useSelector } from "react-redux";
import configureStore from "../../../store/configureStore";
import Bill from "./common/Bill";
import { history } from "../../../reducers";
import Loader from "../../common/Loader";
import { get_purchase_invoice_details } from "./actions/action-purchaseInvoice";
import { get_orgunit_details } from "../../../actions/action-orgunit";
import NewBill from "./common/NewBill";

const store = configureStore();

function PurchaseInvoiceDetails() {
  const dispatch = useDispatch();
  const { activeOuid } = store.getState().permission;
  const { purchaseInvoiceDetails, showGlobalLoader } = useSelector(
    (state) => state.purchaseInvoice
  );
  const { OrgunitDetails } = useSelector((state) => state.orgunit);

  useEffect(() => {
    let invoiceId = window.location.pathname.split("/");
    invoiceId = invoiceId[3];
    console.log("invoiceId", invoiceId);

    console.log("inuseEffect");
    const fetchData = async (dispatch) => {
      await dispatch(get_purchase_invoice_details(invoiceId, activeOuid));
      await dispatch(get_orgunit_details(activeOuid));
    };
    fetchData(dispatch);
  }, [dispatch]);

  return (
    <div>
      <HeaderInner pageTitle="Purchase Invoice Details" />
      <div className="AppPage container--narrow mt FBAppPage">
        <button
          className="bill_edit_btn mb"
          onClick={() =>
            history.push(
              `/${activeOuid}/edit-purchase-invoice/${purchaseInvoiceDetails.id}`
            )
          }
        >
          Edit
        </button>
        {showGlobalLoader ? (
          <Loader />
        ) : (
          <>
            <NewBill
              billDetails={purchaseInvoiceDetails}
              companyDetails={OrgunitDetails}
            />
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}

export default PurchaseInvoiceDetails;
